import { type ElementType, type ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import { Input } from "../input/Input";
import type { FormInputProps } from "./Form.types";
import { FormField } from "./FormField";

const FormInputComponent = (props: FormInputProps): ReactElement => {
  const { control, ...rest } = props;
  return <FormField {...rest} control={(control as ElementType) || Input} />;
};

export const FormInput = styled(FormInputComponent)``;
